<template>
    <div id="telnyx-channel-detail">
        <AppBreadCrumb
            :paths="[{ title: 'Telnyx Channel Detail' }]"
            :select="true"
            class="visitor-detail-bread-crumb"
        >
        </AppBreadCrumb>

        <div class="route-page-content breadcrumb-content" v-if="channel">
            <SidebarChild
                :items="menuItems"
                :selected-item="currentTab"
                :focusActive="true"
                @selected="(i) => (currentTab = i.key)"
            />
            <div class="page-content-wrapper">
                <div class="toolbar">
                    <div class="left">
                        <IconButton :on-click="() => $router.push('/integrations/webphone/telnyx')">
                            <span class="material-icons"> chevron_left </span>
                        </IconButton>
                        <div class="icon-container">
                            <span class="material-icons" style="font-size: 30px; color: #1976d2;">phone</span>
                        </div>
                        <div class="name">Telnyx Kanalı : {{ channel.name }}</div>
                    </div>
                    <div class="right">
                        <a-button type="danger" @click="deleteModal = true">
                            Kanalı Sil
                        </a-button>
                    </div>
                </div>

                <div v-if="currentTab === TelnyxMenuTypes.MENU_TYPES.BALANCE">
                    <TelnyxBalance v-model="channel" />
                </div>
                <div v-if="currentTab === TelnyxMenuTypes.MENU_TYPES.CDR">
                    <TelnyxCDR v-model="channel" />
                </div>
                <div v-if="currentTab === TelnyxMenuTypes.MENU_TYPES.USER_MAPPING">
                    <TelnyxUserMapping v-model="channel" />
                </div>
                <div v-if="currentTab === TelnyxMenuTypes.MENU_TYPES.SETTINGS">
                    <TelnyxSettings v-model="channel" />
                </div>
                <div v-if="currentTab === TelnyxMenuTypes.MENU_TYPES.AUTOMATIONS">
                    <AutomationList type="event" module="webphone" />
                </div>
            </div>
        </div>

        <a-modal
            v-model="deleteModal"
            icon="exclamation-circle"
            :title="'Telnyx Kanalını Sil'"
            @cancel="deleteModal = false"
        >
            <p>Bu Telnyx kanalını silmek istediğinize emin misiniz?</p>
            <template #footer>
                <a-button key="back" @click="deleteModal = false">
                    Vazgeç
                </a-button>
                <a-button key="submit" type="danger" @click="deleteTelnyxChannel">
                    Sil
                </a-button>
            </template>
        </a-modal>
    </div>
</template>

<script>
import Vue from "vue";
import IconButton from "../../../Settings/components/IconButton.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import _ from "lodash";
import log2 from "../../../../../utils/log2";
import TelnyxMenuTypes from "./TelnyxMenuTypes";
import AppBreadCrumb from "../../../../../components/common/AppBreadCrumb.vue";
import SidebarChild from "../../../../../components/Sidebar/SidebarChild.vue";
import TelnyxBalance from "./TelnyxBalance.vue";
import TelnyxCDR from "./TelnyxCDR.vue";
import TelnyxUserMapping from "./TelnyxUserMapping.vue";
import TelnyxSettings from "./TelnyxSettings.vue";
import AutomationList from "../../../Automation/pages/automations/AutomationList.vue";

const log = log2("TelnyxChannelDetail.vue");

export default Vue.extend({
    name: "TelnyxChannelDetail",
    components: {
        TelnyxBalance,
        TelnyxCDR,
        TelnyxUserMapping,
        TelnyxSettings,
        IconButton,
        AppBreadCrumb,
        SidebarChild,
        AutomationList,
    },
    data() {
        const path = (_.last(this.$route.path.split("/")) || "balance").toLowerCase().trim();
        const selected = TelnyxMenuTypes.Items(this).find((x) => x.key === path);
        return {
            currentTab: selected ? selected.key : "balance",
            loading: false,
            selectedChannelId: this.$route.params.id,
            deleteModal: false,
            channel: null,
            TelnyxMenuTypes,
            menuItems: TelnyxMenuTypes.Items(this),
        };
    },
    computed: {
        ...mapState({
            channels: (state) => state.channel.channels.filter((x) => x.type === "webphone-telnyx"),
            siteId: (state) => _.get(state.site.site, "_id"),
            user: (state) => state.auth.user,
            site: (state) => state.site.site,
        }),
    },
    methods: {
        ...mapActions({
            createChannel: "channel/createChannel",
            listChannels: "channel/listChannels",
            deleteChannel: "channel/deleteChannel",
            updateChannel: "channel/updateChannel",
        }),
        changePage(page) {
            this.currentTab = page;
        },
        deleteTelnyxChannel() {
            const channel = this.channel;
            this.deleteChannel(channel._id).then(() => {
                this.$router.push("/integrations/webphone/telnyx");
            });
        },
        handleSave() {
            const isValid = true;
            if (isValid) {
                const payload = this.channel;
                this.loading = true;
                this.updateChannel(payload)
                    .then(() => {
                        this.listChannels();
                        this.$message.success("Kanal başarıyla güncellendi");
                        this.originalChannel = _.cloneDeep(this.channel);
                        this.$emit("ok");
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message.error("Kanal güncellenirken bir hata oluştu");
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
    },
    mounted() {
        this.listChannels().then((channels) => {
            this.channel = channels.find((x) => x._id === this.selectedChannelId);
            this.originalChannel = _.cloneDeep(this.channel);
        });
    },
    watch: {
        channel: {
            handler: function (val) {
                if (val) {
                    const isChanged = !_.isEqual(val, this.originalChannel);
                    if (isChanged) {
                        log("channel changed=>", val);
                        this.handleSave();
                    }
                }
            },
            deep: true,
        },
        currentTab(value) {
            const selected = this.menuItems.find((x) => x.key === value);
            if (selected) {
                this.$router.push(`/integrations/webphone/telnyx/${this.channel._id}/detail/${selected.key}`);
            }
        },
    },
});
</script>

<style scoped lang="scss">
#telnyx-channel-detail {
    display: flex;
    flex-direction: column;
    background: var(--color-bg-default);
    position: relative;
    width: 100%;
    height: 100%;

    .toolbar {
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 50px;
        border-bottom: 1px solid var(--color-border-default);

        .left {
            display: flex;
            align-items: center;
            gap: 5px;

            .name {
                font-size: 18px;
                font-weight: 700;
            }

            .icon-container {
                width: 30px;
                height: 30px;
                display: flex;
                margin: 0 auto;
                align-items: center;
                justify-content: center;
                border-radius: 6px;
                overflow: hidden;
                position: relative;
            }
        }

        .right {
            display: flex;
            justify-content: flex-end;
            gap: 5px;
        }
    }
}
</style> 